import React from 'react';
import { chainName, isTestnetMode, testnetFaucetUrl } from '../../constant/constant';

const TestnetFaucetLink = ({ className = '', compact = false }) => {
    if (!isTestnetMode) return null;

    const label = compact ? 'Faucet' : 'Get testnet USDC';
    const networkHint = chainName || 'Arc';

    return (
        <a
            href={testnetFaucetUrl}
            target="_blank"
            rel="noopener noreferrer"
            title={`Open Circle testnet faucet (${networkHint})`}
            className={`touch-manipulation inline-flex min-h-[36px] items-center gap-1.5 rounded-lg border border-teal-200 bg-teal-50 px-2 py-1.5 text-xs font-semibold text-teal-900 transition-colors hover:border-teal-300 hover:bg-teal-100 dark:border-teal-800 dark:bg-teal-950/50 dark:text-teal-200 dark:hover:border-teal-700 dark:hover:bg-teal-950/80 sm:px-2.5 ${className}`}
        >
            <i className="fa-solid fa-droplet text-[10px]" aria-hidden />
            <span className="hidden sm:inline">{label}</span>
            <span className="sm:hidden">Faucet</span>
            <i className="fa-solid fa-arrow-up-right-from-square text-[9px] opacity-70" aria-hidden />
        </a>
    );
};

export default TestnetFaucetLink;
